<template>
    <div style="width: 100%;display: flex" >
      <div v-for="(child, childIndex) in children" :key="`breadcrumb-${childIndex}`" style="display: flex;">
        <a :href="child.url" style="margin-right: 10px;"><b>{{child.title}}</b></a>
        <div v-if="childIndex !== (children.length - 1)" style="margin-right: 10px;" >/</div>
      </div>
      
    </div>
</template>
<script>
export default{
    name : "bread-crumb",
    props : {
        children : Array
    }
}
</script>